import { render } from "./VabeneLoyaltyReportList.vue?vue&type=template&id=55e8fdec&scoped=true&ts=true"
import script from "./VabeneLoyaltyReportList.vue?vue&type=script&lang=ts"
export * from "./VabeneLoyaltyReportList.vue?vue&type=script&lang=ts"

import "./VabeneLoyaltyReportList.vue?vue&type=style&index=0&id=55e8fdec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e8fdec"]])

export default __exports__